// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================
   Kubersetu Payments Page Glass Styles
   ========================================== */

.payments-container {
  max-width: 500px;
  margin: 0 auto;
  padding: 7.25rem 1.5rem 4rem 1.5rem;
}

.payments-header {
  text-align: center;
  margin-bottom: 2rem;
}

.payments-header h1 {
  font-size: clamp(1.75rem, 4vw, 2.25rem);
  font-weight: 800;
  color: #ffffff;
  margin-bottom: 0.5rem;
}

.payments-header p {
  color: var(--text-muted);
  font-size: 1rem;
}

.tabs {
  display: flex;
  background: rgba(15, 23, 42, 0.7);
  border-radius: var(--radius-md);
  margin-bottom: 2rem;
  overflow: hidden;
  border: 1px solid var(--border-glass);
  padding: 0.25rem;
}

.tab-btn {
  flex: 1 1;
  padding: 0.75rem 1rem;
  border: none;
  background: transparent;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  color: var(--text-muted);
  border-radius: var(--radius-sm);
}

.tab-btn.active {
  background: var(--grad-primary);
  color: #ffffff;
  box-shadow: 0 4px 15px rgba(245, 158, 11, 0.3);
}

.tab-content {
  width: 100%;
}

.payment-card {
  background: var(--bg-glass-card);
  backdrop-filter: blur(20px);
  border-radius: var(--radius-lg);
  padding: 2rem;
  box-shadow: var(--shadow-lg);
  border: 1px solid var(--border-glass);
  margin-bottom: 1.5rem;
}

.payment-card h2 {
  margin-top: 0;
  margin-bottom: 1.5rem;
  font-size: 1.25rem;
  font-weight: 700;
  color: #ffffff;
}

.input-group {
  margin-bottom: 1.5rem;
}

.input-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: var(--text-muted);
  font-size: 0.9rem;
}

.amount-input {
  position: relative;
}

.currency {
  position: absolute;
  left: 1rem;
  top: 50%;
  transform: translateY(-50%);
  font-weight: 600;
  color: var(--color-primary);
}

.input-group input {
  width: 100%;
  padding: 0.85rem 1rem 0.85rem 2.5rem;
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid var(--border-glass);
  border-radius: var(--radius-md);
  color: #ffffff;
  font-size: 1rem;
  transition: all 0.3s ease;
}

.input-group input:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.2);
}

.payment-options {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.payment-option {
  display: flex;
  align-items: center;
  padding: 1rem;
  background: rgba(15, 23, 42, 0.4);
  border: 1px solid var(--border-glass);
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: all 0.3s ease;
}

.payment-option:hover {
  background: rgba(15, 23, 42, 0.8);
}

.payment-option.active {
  border-color: var(--color-primary);
  background: rgba(245, 158, 11, 0.1);
}

.option-icon {
  font-size: 1.5rem;
  margin-right: 1rem;
}

.option-details {
  display: flex;
  flex-direction: column;
}

.option-details span {
  font-weight: 600;
  color: #ffffff;
}

.option-details small {
  color: var(--text-muted);
  font-size: 0.85rem;
}

.submit-btn {
  width: 100%;
  padding: 1rem;
  background: var(--grad-primary);
  color: #ffffff;
  border: none;
  border-radius: var(--radius-md);
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 1rem;
}

.submit-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(245, 158, 11, 0.4);
}

.summary {
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid var(--border-glass);
}

.summary h3 {
  margin-top: 0;
  margin-bottom: 1rem;
  font-size: 1.1rem;
  color: #ffffff;
}

.summary-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.75rem;
  color: var(--text-muted);
}

.summary-row.total {
  font-weight: 700;
  font-size: 1.2rem;
  padding-top: 0.75rem;
  border-top: 1px solid var(--border-glass);
  color: #ffffff;
}

.filters {
  display: flex;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
}

.filters select {
  flex: 1 1;
  padding: 0.75rem 1rem;
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid var(--border-glass);
  border-radius: var(--radius-md);
  color: #ffffff;
  cursor: pointer;
}

.filters select:focus {
  outline: none;
  border-color: var(--color-primary);
}

.transactions {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.transaction {
  display: flex;
  align-items: center;
  padding: 1rem;
  background: rgba(15, 23, 42, 0.4);
  border: 1px solid var(--border-glass);
  border-radius: var(--radius-md);
  transition: all 0.3s ease;
}

.transaction:hover {
  background: rgba(15, 23, 42, 0.7);
}

.transaction-icon {
  width: 40px;
  height: 40px;
  border-radius: var(--radius-full);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
  font-size: 1rem;
}

.transaction-icon.sent {
  background: rgba(239, 68, 68, 0.1);
  color: var(--color-danger);
}

.transaction-icon.received {
  background: rgba(16, 185, 129, 0.1);
  color: var(--color-emerald);
}

.transaction-details {
  flex: 1 1;
}

.transaction-details h4 {
  margin: 0 0 0.25rem 0;
  font-weight: 600;
  color: #ffffff;
}

.transaction-details p {
  margin: 0;
  color: var(--text-muted);
  font-size: 0.85rem;
}

.transaction-amount {
  font-weight: 700;
}

.transaction-amount.sent {
  color: var(--color-danger);
}

.transaction-amount.received {
  color: var(--color-emerald);
}

@media (max-width: 600px) {
  .payments-container {
    padding-top: 5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Payments.css"],"names":[],"mappings":"AAAA;;+CAE+C;;AAE/C;EACE,gBAAgB;EAChB,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,qBAAqB;EACrB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,+BAA+B;EAC/B,aAAa;EACb,4BAA4B;EAC5B,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,iCAAiC;EACjC,qCAAqC;EACrC,+BAA+B;EAC/B,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,iCAAiC;EACjC,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,+BAA+B;EAC/B,cAAc;EACd,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,qBAAqB;EACrB,iCAAiC;EACjC,qCAAqC;EACrC,+BAA+B;EAC/B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,iCAAiC;EACjC,qCAAqC;EACrC,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* ==========================================\n   Kubersetu Payments Page Glass Styles\n   ========================================== */\n\n.payments-container {\n  max-width: 500px;\n  margin: 0 auto;\n  padding: 7.25rem 1.5rem 4rem 1.5rem;\n}\n\n.payments-header {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.payments-header h1 {\n  font-size: clamp(1.75rem, 4vw, 2.25rem);\n  font-weight: 800;\n  color: #ffffff;\n  margin-bottom: 0.5rem;\n}\n\n.payments-header p {\n  color: var(--text-muted);\n  font-size: 1rem;\n}\n\n.tabs {\n  display: flex;\n  background: rgba(15, 23, 42, 0.7);\n  border-radius: var(--radius-md);\n  margin-bottom: 2rem;\n  overflow: hidden;\n  border: 1px solid var(--border-glass);\n  padding: 0.25rem;\n}\n\n.tab-btn {\n  flex: 1;\n  padding: 0.75rem 1rem;\n  border: none;\n  background: transparent;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  color: var(--text-muted);\n  border-radius: var(--radius-sm);\n}\n\n.tab-btn.active {\n  background: var(--grad-primary);\n  color: #ffffff;\n  box-shadow: 0 4px 15px rgba(245, 158, 11, 0.3);\n}\n\n.tab-content {\n  width: 100%;\n}\n\n.payment-card {\n  background: var(--bg-glass-card);\n  backdrop-filter: blur(20px);\n  border-radius: var(--radius-lg);\n  padding: 2rem;\n  box-shadow: var(--shadow-lg);\n  border: 1px solid var(--border-glass);\n  margin-bottom: 1.5rem;\n}\n\n.payment-card h2 {\n  margin-top: 0;\n  margin-bottom: 1.5rem;\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.input-group {\n  margin-bottom: 1.5rem;\n}\n\n.input-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  color: var(--text-muted);\n  font-size: 0.9rem;\n}\n\n.amount-input {\n  position: relative;\n}\n\n.currency {\n  position: absolute;\n  left: 1rem;\n  top: 50%;\n  transform: translateY(-50%);\n  font-weight: 600;\n  color: var(--color-primary);\n}\n\n.input-group input {\n  width: 100%;\n  padding: 0.85rem 1rem 0.85rem 2.5rem;\n  background: rgba(15, 23, 42, 0.6);\n  border: 1px solid var(--border-glass);\n  border-radius: var(--radius-md);\n  color: #ffffff;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n}\n\n.input-group input:focus {\n  outline: none;\n  border-color: var(--color-primary);\n  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.2);\n}\n\n.payment-options {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.payment-option {\n  display: flex;\n  align-items: center;\n  padding: 1rem;\n  background: rgba(15, 23, 42, 0.4);\n  border: 1px solid var(--border-glass);\n  border-radius: var(--radius-md);\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.payment-option:hover {\n  background: rgba(15, 23, 42, 0.8);\n}\n\n.payment-option.active {\n  border-color: var(--color-primary);\n  background: rgba(245, 158, 11, 0.1);\n}\n\n.option-icon {\n  font-size: 1.5rem;\n  margin-right: 1rem;\n}\n\n.option-details {\n  display: flex;\n  flex-direction: column;\n}\n\n.option-details span {\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.option-details small {\n  color: var(--text-muted);\n  font-size: 0.85rem;\n}\n\n.submit-btn {\n  width: 100%;\n  padding: 1rem;\n  background: var(--grad-primary);\n  color: #ffffff;\n  border: none;\n  border-radius: var(--radius-md);\n  font-size: 1rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-top: 1rem;\n}\n\n.submit-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(245, 158, 11, 0.4);\n}\n\n.summary {\n  margin-top: 2rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid var(--border-glass);\n}\n\n.summary h3 {\n  margin-top: 0;\n  margin-bottom: 1rem;\n  font-size: 1.1rem;\n  color: #ffffff;\n}\n\n.summary-row {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 0.75rem;\n  color: var(--text-muted);\n}\n\n.summary-row.total {\n  font-weight: 700;\n  font-size: 1.2rem;\n  padding-top: 0.75rem;\n  border-top: 1px solid var(--border-glass);\n  color: #ffffff;\n}\n\n.filters {\n  display: flex;\n  gap: 0.75rem;\n  margin-bottom: 1.5rem;\n}\n\n.filters select {\n  flex: 1;\n  padding: 0.75rem 1rem;\n  background: rgba(15, 23, 42, 0.6);\n  border: 1px solid var(--border-glass);\n  border-radius: var(--radius-md);\n  color: #ffffff;\n  cursor: pointer;\n}\n\n.filters select:focus {\n  outline: none;\n  border-color: var(--color-primary);\n}\n\n.transactions {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.transaction {\n  display: flex;\n  align-items: center;\n  padding: 1rem;\n  background: rgba(15, 23, 42, 0.4);\n  border: 1px solid var(--border-glass);\n  border-radius: var(--radius-md);\n  transition: all 0.3s ease;\n}\n\n.transaction:hover {\n  background: rgba(15, 23, 42, 0.7);\n}\n\n.transaction-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: var(--radius-full);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 1rem;\n  font-size: 1rem;\n}\n\n.transaction-icon.sent {\n  background: rgba(239, 68, 68, 0.1);\n  color: var(--color-danger);\n}\n\n.transaction-icon.received {\n  background: rgba(16, 185, 129, 0.1);\n  color: var(--color-emerald);\n}\n\n.transaction-details {\n  flex: 1;\n}\n\n.transaction-details h4 {\n  margin: 0 0 0.25rem 0;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.transaction-details p {\n  margin: 0;\n  color: var(--text-muted);\n  font-size: 0.85rem;\n}\n\n.transaction-amount {\n  font-weight: 700;\n}\n\n.transaction-amount.sent {\n  color: var(--color-danger);\n}\n\n.transaction-amount.received {\n  color: var(--color-emerald);\n}\n\n@media (max-width: 600px) {\n  .payments-container {\n    padding-top: 5rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
